<template>
  <div>
    <div class="d-flex justify-content-between" v-if="results.length == 0">
      <input
        type="text"
        :value="hiddenValue"
        :ref="'inputRefBusinessName'"
        class="w-100"
        placeholder="Business Name"
        @input="handleInput($event)"
        name="business_name"
      />
      <el-button
        plain
        class="btn-secondary px-2 py-1 h-100"
        style="height: 42px !important"
        @click="getABNData('name')"
        :loading="loading"
        type="button"
      >
        <i class="fa fa-search font-14"></i>
      </el-button>
    </div>
    <div v-else>
      <button
        type="button"
        class="btn btn-link fa-sm text-grey p-0 float-right"
        style="position: absolute; right: 0px; top: -25px"
        @click="clear"
      >
        New search
      </button>
      <el-select
        v-model="businessSelected"
        placeholder="Select Business"
        class="w-100"
        clearable
        filterable
        @change="onSelect"
      >
        <el-option
          v-for="(item, index) in results"
          :key="index"
          :label="getName(item)"
          :value="item.ABN.identifierValue"
          class="business-lookup-options"
        >
          <div class="fa-sm text-grey" style="text-transform: capitalize">
            <strong>Name:</strong> {{ getName(item) }}
          </div>
          <div class="fa-sm text-grey">
            <strong>ABN:</strong> {{ item.ABN.identifierValue }}
            <i
              class="fa fa-circle fa-sm"
              :class="
                item.ABN.identifierStatus == 'Cancelled'
                  ? 'text-danger'
                  : 'text-success'
              "
            ></i>
          </div>
          <div class="fa-sm text-grey">
            <strong>Postcode:</strong>
            {{ item.mainBusinessPhysicalAddress.postcode }}
          </div>
          <div class="fa-sm text-grey">
            <strong>State:</strong>
            {{ item.mainBusinessPhysicalAddress.stateCode }}
          </div>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import ABNFormat from "../mixins/ABNFormat";
import AbnLookup from "../frontend/modelsPortal/common/AbnLookup";
export default {
  mixins: [ABNFormat],
  name: "InputBusinessName",
  model: {
    prop: "hiddenValue",
    event: "blur",
  },
  props: {
    hiddenValue: {
      type: [String, Number],
    },
    returnList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      found: false,
      name: this.hiddenValue,
      results: [],
      businessSelected: null,
    };
  },
  computed: {},
  methods: {
    clear() {
      //this.hiddenValue = this.hiddenValue;
      this.businessSelected = null;
      this.results = [];
    },
    onSelect() {
      if (this.businessSelected) {
        this.getABNData("abn");
        this.clear();
      }
    },
    getName(item) {
      let name = null;
      if (item.businessName) {
        name = item.businessName.organisationName;
      }
      if (item.mainName) {
        name = item.mainName.organisationName;
      }
      if (item.mainTradingName) {
        name = item.mainTradingName.organisationName;
      }
      if (item.otherTradingName) {
        name = item.otherTradingName.organisationName;
      }
      if (item.legalName) {
        name = item.legalName.fullName;
      }
      return name ? name.toLowerCase() : "";
    },
    getABNData(searchBy = "name") {
      let input = null;
      let params = null;
      if (searchBy == "name") {
        input = this.hiddenValue;
        params = { name: input };
      } else {
        input = this.businessSelected;
        params = { abn: input };
      }
      if (input) {
        this.loading = true;
        new AbnLookup()
          .params(params)
          .get()
          .then((res) => {
            if (searchBy == "name") {
              if (this.returnList) {
                this.$emit(
                  "show-list",
                  res.filter((item) => item.ABN.identifierStatus != "Cancelled")
                );
              } else this.results = res;
            } else {
              let abnData = res[0];
              this.$emit("data", abnData);
              //this.hiddenValue = abnData.name;
            }
          })
          .catch((err) => {
            this.$message.error("Looks like something went wrong.");
          })
          .finally((_) => {
            this.loading = false;
          });
        return;
      }
    },
    handleInput(event) {
      const vm = this;

      // Now unmask the value by applying reverse logic
      let value = event.target.value;

      // Emit the blur event so it automatically sets the hiddenValue
      vm.$emit("blur", value);

      this.$forceUpdate();
    },
  },
};
</script>
<style>
.business-lookup-options {
  height: auto !important;
  border-bottom: 1px solid #c8ced3 !important;
  line-height: 20px !important;
  padding: 5px 20px;
}
</style>
